import React, { useEffect, useState } from "react";
import FixedDecimalTextField from "../components/FixedDecimalTextField";
import { canonicalNumericValue } from "../utilities/numericInput";

const SummaryNumber = ({
  item,
  handleSummaryUpdate,
  id,
  formAction,
  defaultTableEditData,
  documentSelectTableData,
}) => {
  const component = item?.inputType?.component;

  const getInitialValue = () => {
    if (documentSelectTableData?.length > 0) {
      const itemObj = documentSelectTableData?.[0]?.tablesummary?.find(
        summItem => summItem?.sSummaryID === item?.sSummaryID
      );

      if (itemObj) {
        return itemObj?.sValue;
      }
    }

    if (formAction === "EDIT") {
      const itemObj = defaultTableEditData?.[0]?.tablesummary?.find(
        summItem => summItem?.sSummaryID === item?.sSummaryID
      );

      if (itemObj) {
        return itemObj?.sValue;
      }
    }

    return component?.sDefaultValue ?? "0";
  };
  const [localValue, setLocalValue] = useState(getInitialValue);

  useEffect(() => {
    const nextValue = getInitialValue();
    setLocalValue(nextValue);

    if (formAction !== "EDIT" && documentSelectTableData?.length === 0) {
      handleSummaryUpdate(
        item?.sSummaryID,
        canonicalNumericValue(nextValue, component),
        item,
      );
    }
  }, [defaultTableEditData, documentSelectTableData]);

  return (
    <FixedDecimalTextField
      component={component}
      placeholder={component?.sPlaceHolder}
      value={localValue}
      onValueChange={value => {
        setLocalValue(value);
        handleSummaryUpdate(item?.sSummaryID, value, item);
      }}
      id={id}
    />
  );
};

export default SummaryNumber;
